import "./SingleExperienceTemplate.module.css"
import MainNavigation from "@/reusable_sections/Header"
import SingleExperienceTemplateSection from "./sections/SingleExperienceTemplateSection"
import SariHutFooter from "@/reusable_sections/Footer"

export default function SingleExperienceTemplatePage() {

  return (
    <div>
      <MainNavigation />
      <SingleExperienceTemplateSection />
      <SariHutFooter />
    </div>
  )
}
